<template>
  <div class="container">
    <div class="mwow-form">
      <p class="title">意向学员设置</p>
      <div class="form-item">
        <el-switch
          @change="handleSwitchChange('first_follow_up')"
          v-model="mainForm.first_follow_up.switch"
        ></el-switch>
        <span class="text">没有跟进记录的学员分配后，超过</span>
        <el-input
          v-model="mainForm.first_follow_up.exceed_day"
          type="number"
          @change="
            (v) => {
              handleDayChange('first_follow_up');
            }
          "
        ></el-input>
        <span class="text">天没有跟进记录，系统自动收回重新分配</span>
        <el-popover
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="170"
        >
          <p>
            分配后，有交易记录或新体验记录，没有新的跟进记录系统不会自动收回
          </p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin: 0 0 0 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: text-bottom;
            "
          ></i>
        </el-popover>
      </div>
      <div class="form-item">
        <el-switch
          @change="handleSwitchChange('second_follow_up')"
          v-model="mainForm.second_follow_up.switch"
        ></el-switch>
        <span class="text">有跟进记录的学员分配后，超过</span>
        <el-input
          v-model="mainForm.second_follow_up.exceed_day"
          type="number"
          @change="
            (v) => {
              handleDayChange('second_follow_up');
            }
          "
        ></el-input>
        <span class="text">天没有跟进记录，系统自动收回重新分配</span>
        <el-popover
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="170"
        >
          <p>
            分配后，有交易记录或新体验记录，没有新的跟进记录系统不会自动收回
          </p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin: 0 0 0 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: text-bottom;
            "
          ></i>
        </el-popover>
      </div>
      <div class="form-item">
        <el-switch
          @change="handleSwitchChange('potential_active_claim')"
          v-model="mainForm.potential_active_claim.switch"
        ></el-switch>
        <span class="text">公海池主动认领学员后，超过</span>
        <el-input
          v-model="mainForm.potential_active_claim.exceed_day"
          type="number"
          @change="
            (v) => {
              handleDayChange('potential_active_claim');
            }
          "
        ></el-input>
        <span class="text">天没有跟进记录，系统自动收回重新分配</span>
        <el-popover
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="170"
        >
          <p>
            主动认领后，有交易记录或新体验记录，没有新的跟进记录系统不会自动收回
          </p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin: 0 0 0 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: text-bottom;
            "
          ></i>
        </el-popover>
      </div>
      <div class="form-item">
        <el-switch
          @change="handleSwitchChange('experience_record')"
          v-model="mainForm.experience_record.switch"
        ></el-switch>
        <span class="text">分配后超过</span>
        <el-input
          v-model="mainForm.experience_record.exceed_day"
          type="number"
          @change="
            (v) => {
              handleDayChange('experience_record');
            }
          "
        ></el-input>
        <span class="text">天学员没有体验记录，系统自动收回重新分配</span>
        <el-popover
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="170"
        >
          <p>分配后，有交易记录或历史体验记录，没有新的体验记录不会自动收回</p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin: 0 0 0 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: text-bottom;
            "
          ></i>
        </el-popover>
      </div>
      <div class="form-item">
        <el-switch
          @change="handleSwitchChange('course_transform_success')"
          v-model="mainForm.course_transform_success.switch"
        ></el-switch>
        <span class="text">分配后超过</span>
        <el-input
          v-model="mainForm.course_transform_success.exceed_day"
          type="number"
          @change="
            (v) => {
              handleDayChange('course_transform_success');
            }
          "
        ></el-input>
        <span class="text">天学员没有转化成功购课，系统自动收回重新分配</span>
        <el-popover
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="170"
        >
          <p>分配后，有交易记录，系统不会自动收回</p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin: 0 0 0 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: text-bottom;
            "
          ></i>
        </el-popover>
      </div>
      <p class="title">公海池设置</p>
      <div class="form-item">
        <el-switch
          v-model="mainForm.potential_whether_claim.switch"
          @change="handleSwitchChange('potential_whether_claim')"
        ></el-switch>
        <span class="text">公海池学员支持课程顾问认领</span>
      </div>
      <div class="form-item">
        <el-switch
          v-model="mainForm.recovery_whether_potential.switch"
          @change="handleSwitchChange('recovery_whether_potential')"
        ></el-switch>
        <span class="text"
          >系统自动收回或课程顾问主动放弃学员是否进入公海池</span
        >
      </div>
    </div>
    <div class="bottom-tips">
      <p>1、系统会在次日00:00-06:00统一将符合条件的自动收回</p>
      <p>
        2、学员被自动收回后，不再归属于原课程顾问，若学员被放入公海池，不允许原课程顾问主动认领；管理员可以重新分配给原课程顾问
      </p>
      <p>
        3、课程顾问主动放弃学员，若学员被放入公海池后，课程顾问可以主动认领回来，分配学员的时间按照上一次的分配时间计算
      </p>
    </div>
  </div>
</template>
<script>
import {
  getIntentionStudentConfigApi,
  editIntentionStudentConfigApi,
} from "@/api/storeManagement";
export default {
  data() {
    // first_follow_up=没有跟进记录的学员分配后超N天没有跟进记录系统自动回收
    // second_follow_up=有跟进记录的学员分配后超N天没有跟进记录系统自动回收
    // potential_active_claim=公海池主动认领学员后超N天没有跟进记录系统自动回收
    // experience_record=超N天学员没有体验记录，系统自动收回重新分配
    // course_transform_success=超N天学员没有转化成功购课，系统自动收回重新分配
    // potential_whether_claim=公海池学员支持课程顾问认领
    // recovery_whether_potential=系统自动收回或课程顾问主动放弃学员是否进入公海池
    return {
      mainForm: {
        first_follow_up: {
          id: 0,
          config_key: "",
          switch: false,
          exceed_day: "",
          exceed_day_bk: "",
        },
        second_follow_up: {
          id: 0,
          config_key: "",
          switch: false,
          exceed_day: "",
          exceed_day_bk: "",
        },
        potential_active_claim: {
          id: 0,
          config_key: "",
          switch: false,
          exceed_day: "",
          exceed_day_bk: "",
        },
        experience_record: {
          id: 0,
          config_key: "",
          switch: false,
          exceed_day: "",
          exceed_day_bk: "",
        },
        course_transform_success: {
          id: 0,
          config_key: "",
          switch: false,
          exceed_day: "",
          exceed_day_bk: "",
        },
        potential_whether_claim: {
          id: 0,
          config_key: "",
          switch: false,
          exceed_day: "",
          exceed_day_bk: "",
        },
        recovery_whether_potential: {
          id: 0,
          config_key: "",
          switch: false,
          exceed_day: "",
          exceed_day_bk: "",
        },
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getIntentionStudentConfigApi().then((res) => {
        res.data.list.map((item) => {
          this.mainForm[item.config_key] = {
            id: item.id,
            config_key: item.config_key,
            switch: item.switch === 1,
            exceed_day: item.switch === 1 ? item.exceed_day : "",
            exceed_day_bk: item.exceed_day,
          };
        });
      });
    },
    handleSwitchChange(key) {
      let open = this.mainForm[key].switch;
      let params = {
        config_key: key,
        switch: open ? 1 : 2,
      };
      params.exceed_day = Number(this.mainForm[key].exceed_day_bk) || 1;
      editIntentionStudentConfigApi(params)
        .then(() => {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.init();
        })
        .catch(() => {
          this.init();
        });
    },
    handleDayChange(key) {
      let day = Number(this.mainForm[key].exceed_day);
      let day_bk = this.mainForm[key].exceed_day_bk;
      let open = this.mainForm[key].switch;
      if (!open) {
        this.$message({
          type: "warning",
          message: "请先打开设置开关",
        });
        this.mainForm[key].exceed_day = "";
        return false;
      }
      if (day < 1) {
        this.$message({
          type: "warning",
          message: "天数不可小于1",
        });
        this.mainForm[key].exceed_day = day_bk;
        return false;
      }
      if (day > 99999) {
        this.$message({
          type: "warning",
          message: "天数过大",
        });
        this.mainForm[key].exceed_day = day_bk;
        return false;
      }
      this.mainForm[key].exceed_day = Math.floor(day);
      editIntentionStudentConfigApi({
        config_key: key,
        switch: open ? 1 : 2,
        exceed_day: Math.floor(day),
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.init();
        })
        .catch(() => {
          this.init();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  .mwow-form {
    margin-top: 24px;
    margin-bottom: 42px;
    .title {
      font-size: 16px;
      line-height: 16px;
      color: #5c5d5e;
      margin-bottom: 24px;
      font-weight: bold;
    }
    .form-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      margin-left: 30px;
      .el-switch {
        margin-right: 12px;
      }
      .el-input {
        width: 80px;
        margin: 0 6px;
      }
      .text {
        font-size: 14px;
        line-height: 14px;
        color: #5c5d5e;
        white-space: nowrap;
      }
    }
  }
  .bottom-tips {
    background-color: #eee;
    padding: 12px 24px;
    p {
      font-size: 14px;
      line-height: 24px;
      color: #5c5d5e;
    }
  }
}
</style>
